import {isEmpty} from '@/util/helpers.js';
import {value} from 'lodash/seq';

export function validationRule(array, item, itemFields) {
  if (array === undefined) return [];
  const rules = [];

  for (let i = 0; i < array.length; i++) {
    const rule = array[i];
    if (typeof rule === 'function') {
      rules.push((v) => {
        // console.log('validationRule : ', item);
        if (isEmpty(item)) return true;
        return rule(v);
      });
      continue;
    }
    if (rule === 'only_number') {
      rules.push(value => onlyNumber(value))
    }
    if (rule.startsWith('sameTo')) {
      const field = rule.split(':')[1];
      rules.push(value => value === item[field] || `需要跟「${itemFields[field].text}」相同`);
    }
  }
  return rules;
}

export function onlyNumber(value) {
  return value === null || value === undefined || value.toString().length === 0 || /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(value) || '只能輸入數字';
}

export function onlyNumberNotEmpty(value) {
  return value === null || value === undefined || /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/.test(value) || '只能輸入數字';
}

export function validateNull(value = '欄位不能為空') {
  return r => isEmpty(r) ? value : true;
}

export function validateEmail(r) {
  const emailRegex = /.+@.+\..+/;
  return emailRegex.test(r) ? false : true;
}

export function validatePhoneNumber(v) {
  const phoneRegex = /^09\d{8}$/;
  return phoneRegex.test(v) ? false : true;
}

export function validatePhone(v) {
  // 手机号码的正则表达式：以 09 开头，后面跟 8 位数字
  const mobilePhoneRegex = /^09\d{8}$/;

  // 市话号码的正则表达式：以 0 开头，后面跟 2-4 位数字（区号）和 6-8 位数字（本地号码）
  const landlinePhoneRegex = /^0\d{1,4}\d{6,8}$/;

  // 检查电话号码是否符合手机号码或市话号码的格式
  return !(mobilePhoneRegex.test(v) || landlinePhoneRegex.test(v));
}
